
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Map from "../../../Base/Map.vue";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { City, CityPoint } from "@/models/City";
import { MapOptions } from "@/models/Map";
import { forIn, isEqual } from "lodash";
import DeleteBox from "../../../Base/DeleteBox.vue";
import DateHelper from "@/utils/DateHelper";

@Component({
  components: {
    Map,
    DeleteBox,
  },
})
class PoiGeneral extends Vue {
  @Prop({ default: null }) readonly mapPoi!: ManhuntMapPoi;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: null }) readonly gameUid!: string;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  mapPoiClone = {} as ManhuntMapPoi;
  selectedCity = "";
  poiType = "person";
  lat = 0;
  lng = 0;

  get isStartZone(): boolean {
    if (this.mapPoi.title.en === "START_ZONE") {
      return true;
    }
    return false;
  }

  get getCurrentMapLocation(): MapOptions {
    var val = this.cityData.locations[this.mapPoi.loc.loc_uid];
    if (val !== undefined) {
      this.lat = val.lat_long.latitude;
      this.lng = val.lat_long.longitude;
      var locationMarker: MapOptions = {
        position: {
          lat: this.lat,
          lng: this.lng,
        },
        title: this.mapPoi.title.en,
        draggable: true,
        clickable: true,
        slug: val.slug,
        radius: this.mapPoi.loc.geo_rad_m,
        color: this.mapPoi.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
        zIndex: 10011,
        icon: DateHelper.getMapImage(this.mapPoi),
      };
      return locationMarker;
    } else {
      this.lat = this.mapPoi.loc.override_ll.latitude;
      this.lng = this.mapPoi.loc.override_ll.longitude;
      var locationMarker2: MapOptions = {
        position: {
          lat: this.lat,
          lng: this.lng,
        },
        title: this.mapPoi.title.en,
        draggable: true,
        clickable: true,
        slug: this.mapPoi.title.en,
        radius: this.mapPoi.loc.geo_rad_m,
        color: this.mapPoi.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
        zIndex: 10011,
        icon: DateHelper.getMapImage(this.mapPoi),
      };
      return locationMarker2;
    }
  }

  get getLocationsArray(): CityPoint[] {
    const arr: CityPoint[] = [];
    forIn(this.cityData.locations, (val: CityPoint) => {
      arr.push(val);
    });
    return arr;
  }

  get getWarningArray(): string[] {
    const arr: string[] = [];
    forIn(this.mapPoi.issues?.warn, (val: any) => {
      arr.push(val.txt.en);
    });
    return arr;
  }

  get getErrorArray(): string[] {
    const arr: string[] = [];
    forIn(this.mapPoi.issues?.err, (val: any) => {
      arr.push(val.txt.en);
    });
    return arr;
  }

  get getLocationsMap(): MapOptions[] {
    var arr: MapOptions[] = [];
    try {
      forIn(this.cityData.locations, (val: CityPoint) => {
        var mapPoiExist = this.getMapPoiData.find(
          (x) => x.loc.loc_uid === val.slug
        );
        if (mapPoiExist === undefined && this.mapPoi.loc.loc_uid !== val.slug) {
          if (val.slug !== "centre_point") {
            var locationMarker: MapOptions = {
              position: {
                lat: val.lat_long.latitude,
                lng: val.lat_long.longitude,
              },
              title: val.name.en,
              slug: val.slug,
              draggable: false,
              clickable: true,
              zIndex: 100,
              icon: require("@/assets/images/map/city-gray.svg"),
            };

            arr.push(locationMarker);
          }
        }
      });
      this.getMapPoiData.forEach((val: ManhuntMapPoi) => {
        if (val.key !== this.mapPoi.key) {
          var cityData = this.getLocationsArray.find(
            (x: CityPoint) => val.loc.loc_uid === x.slug
          );
          var locationMarker2: MapOptions = {
            position: {
              lat:
                cityData !== undefined && cityData.lat_long !== undefined
                  ? cityData!.lat_long.latitude
                  : val.loc.override_ll.latitude,
              lng:
                cityData !== undefined && cityData.lat_long !== undefined
                  ? cityData!.lat_long.longitude
                  : val.loc.override_ll.longitude,
            },
            title: val.title.en,
            draggable: false,
            clickable: true,
            slug: val.key,
            radius: val.loc.geo_rad_m,
            color: val.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
            zIndex: 1001,
            icon: this.getIconChoice(val),
          };
          arr.push(locationMarker2);
        }
      });
      arr.push(this.getCurrentMapLocation);
      return arr;
    } catch (error) {
      console.log(error);
      return arr;
    }
  }

  getIconChoice(val: ManhuntMapPoi): string {
    if (this.mapPoi.map_mods !== undefined) {
      if (
        this.mapPoi.map_mods.active &&
        (this.mapPoi.map_mods.type === "runaway" ||
          this.mapPoi.map_mods.type === "trigger")
      ) {
        if (this.mapPoi.map_mods.type === "runaway") {
          if (
            this.mapPoi.map_mods.runaway !== undefined &&
            this.mapPoi.map_mods.runaway?.targets !== undefined &&
            this.mapPoi.map_mods.runaway?.targets![val.key] !== undefined
          ) {
            return require("@/assets/images/map/target-purple.svg");
          } else {
            return DateHelper.getGreyMapImage(val);
          }
        } else {
          if (
            this.mapPoi.map_mods.trigger_list !== undefined &&
            this.mapPoi.map_mods.trigger_list![val.key] !== undefined
          ) {
            return require("@/assets/images/map/target-green.svg");
          } else {
            return DateHelper.getGreyMapImage(val);
          }
        }
      } else {
        return DateHelper.getGreyMapImage(val);
      }
    } else {
      return DateHelper.getGreyMapImage(val);
    }
  }

  get getPoiType(): string[] {
    return this.$store.state.mapPoiStore.poiTypes;
  }

  get getMapPoiData(): ManhuntMapPoi[] {
    return this.$store.state.mapPoiStore.mapPoi;
  }

  get getLocations(): any[] {
    const arr: any = [];
    forIn(this.cityData.locations, (val: CityPoint) => {
      if (this.mapPoi.loc.loc_uid === val.slug) {
        arr.push({ value: val.slug, text: val.name.en });
      } else {
        var mapPoiExist = this.getMapPoiData.find(
          (x) => x.loc.loc_uid === val.slug
        );
        if (mapPoiExist === undefined) {
          arr.push({ value: val.slug, text: val.name.en });
        }
      }
    });
    return arr;
  }

  get centerPoint(): any {
    return {
      latitude: this.lat,
      longitude: this.lng,
    };
  }

  get getTargetBy(): string[] {
    let targetedByNames: string[] = [];
    if (this.mapPoi.map_mods.targetedBy !== undefined) {
      if (this.mapPoi.map_mods.targetedBy?.trigger !== undefined) {
        const triggerKeys = Object.keys(
          this.mapPoi.map_mods.targetedBy.trigger
        );
        triggerKeys.map((key) => {
          targetedByNames.push(
            this.getMapPoiData.find((x) => x.key == key)?.title.en +
              "[" +
              key +
              "]"
          );
        });
      }
      if (this.mapPoi.map_mods.targetedBy?.runaway !== undefined) {
        const runawayKeys = Object.keys(
          this.mapPoi.map_mods.targetedBy.runaway
        );
        runawayKeys.map((key) => {
          targetedByNames.push(
            this.getMapPoiData.find((x) => x.key == key)?.title.en +
              "[" +
              key +
              "]"
          );
        });
      }
    }
    return targetedByNames;
  }
  get getRunawayBy(): string[] {
    let targetedByNames: string[] = [];
    if (this.mapPoi.map_mods.runaway?.targets !== undefined) {
      const runawayKeys = Object.keys(this.mapPoi.map_mods.runaway.targets);
      runawayKeys.map((key) => {
        targetedByNames.push(
          this.getMapPoiData.find((x) => x.key == key)?.title.en +
            " [" +
            key +
            "]"
        );
      });
    }
    return targetedByNames;
  }
  get getTriggerBy(): string[] {
    let targetedByNames: string[] = [];
    if (this.mapPoi.map_mods.trigger_list !== undefined) {
      const triggerKeys = Object.keys(this.mapPoi.map_mods.trigger_list);
      triggerKeys.map((key) => {
        targetedByNames.push(
          this.getMapPoiData.find((x) => x.key == key)?.title.en +
            " [" +
            key +
            "]"
        );
      });
    }
    return targetedByNames;
  }

  created(): void {
    if (this.mapPoi.type !== undefined) {
      this.poiType = this.mapPoi.type;
    }
    this.selectedCity = this.mapPoi.loc.loc_uid;
  }

  onValueChanged(): void {
    this.mapPoi.type = this.poiType;
    if (!isEqual(this.mapPoi, this.mapPoiClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
  }

  @Watch("isSavedOrDiscard")
  onisSaveOrDiscardChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }

  openDeleteBox(): void {
    if (this.checkNotTriggers()) {
      this.$bvModal.show("team-modal-delete");
    } else {
      this.$bvModal.show("modal-alert-delete-box");
    }
  }

  deleteItem(): void {
    var data = {
      gameUid: this.gameUid,
      key: this.mapPoi.key,
    };
    this.$store.dispatch("mapPoiStore/deletePoi", data);
    this.$emit("closeDialog");
  }

  close(): void {
    this.$bvModal.hide("modal-alert-delete-box");
  }

  checkNotTriggers(): boolean {
    if (
      this.mapPoi.map_mods.targetedBy === undefined &&
      this.mapPoi.map_mods.runaway?.targets === undefined &&
      this.mapPoi.map_mods.trigger_list === undefined
    ) {
      return true;
    }
    return false;
  }

  mapData(place: any): void {
    this.lat = place.latitude;
    this.lng = place.longitude;
    this.selectedCity = "";
    this.mapPoi.loc.loc_uid = "";
    this.mapPoi.loc.override_ll.latitude = place.latitude;
    this.mapPoi.loc.override_ll.longitude = place.longitude;
    this.onValueChanged();
  }

  changeLocation(slug: string): void {
    const location = this.getLocationsArray.find((x) => x.slug === slug);
    this.mapPoi.loc.loc_uid = slug;
    this.selectedCity = slug;
    if (location !== undefined) {
      this.lat = location.lat_long.latitude || 0;
      this.lng = location.lat_long.longitude || 0;
    }
    this.onValueChanged();
  }
  openLocation(slug: string): void {
    const location = this.getLocationsArray.find((x) => x.slug === slug);
    this.mapPoi.loc.loc_uid = slug;
    this.selectedCity = slug;
    if (location !== undefined) {
      this.lat = location.lat_long.latitude || 0;
      this.lng = location.lat_long.longitude || 0;
    }
    this.onValueChanged();
  }
}

export default PoiGeneral;
